import HomologousProcedureScreen from './HomologousProcedureScreen.js';

export default HomologousProcedureScreen;
